<div class="modal fade" id="editAddModal-2" tabindex="-1" aria-labelledby="exampleEditModalLabel" aria-hidden="true">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()"   
      style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="exampleEditModalLabel">{{ isEdit ? "Update Power Transformer" : "Add New Power Transformer" }}</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal" aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <p class="description-text">{{ isEdit ? "Fill out the fields carefully to update this instance, including all necessary information for identification." : "Fill out the fields carefully to create a new instance, including all necessary information for identification." }}</p>
        <div class="new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
          
          <div *ngIf="!isOpenedFromSubstation" class="section w-100 row">
            
            <ng-container *ngIf="!isEdit">
              <div class="label-div d-flex align-items-center justify-content-left col-6">
                <p>Parent Class (Substation)</p>
              </div>
              <div class="col-6">
                <lib-object-dropdown
                    [items]="substationTemplateOptions"
                    [displayField]="'className'" 
                    [initialValue]="substationTemplateValue"
                    (valueChange)="onSelectSubstationTemplate($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #substationTemplateDropdown
                ></lib-object-dropdown>
              </div>
              <div class="label-div d-flex align-items-center justify-content-left col-6 asset-spacing">
                <p>Asset Name</p>
              </div>
              <div class="col-6 asset-spacing" [ngClass]="{ 'disabled': selectedSubstationTemplate === 0 }">
                <lib-object-dropdown
                  [items]="substationOptions"
                  [displayField]="'name'" 
                  [initialValue]="substationTemplateInstanceValue"
                  (valueChange)="onSelectSubstationTemplateInstance($event)"
                  [disabled]="false"
                  [isRequired]="true"
                  [isSearchEnabled]="true"
                  [maxDisplayItemSize]="10"
                  (searchTextChange)="onSearchTextChange($event)"
                  #substationTemplateInstanceDropdown
                ></lib-object-dropdown>
              </div>
            </ng-container>
            
            <!-- EDIT MODE: Show disabled input fields -->
            <ng-container *ngIf="isEdit">
              <div class="label-div d-flex align-items-center justify-content-left col-6">
                <p>Parent Class (Substation)</p>
              </div>
              <div class="col-6">
                <input
                  class="new-instance-input w-100" 
                  type="text" 
                  [value]="editModeParentClass"
                  disabled
                  placeholder=" "
                />
              </div>
              <div class="label-div d-flex align-items-center justify-content-left col-6 asset-spacing">
                <p>Asset Name</p>
              </div>
              <div class="col-6 asset-spacing">
                <input
                  class="new-instance-input w-100" 
                  type="text" 
                  [value]="editModeAssetName"
                  disabled
                  placeholder=" "
                />
              </div>
            </ng-container>
            
          </div>
          
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Transformer Name</p>
            </div>
            <div class="col-6 asset-spacing">
              <input
                class="new-instance-input w-100" 
                type="text" 
                name="transformerName"
                [(ngModel)]="selectedPowerTransformer.name"
                placeholder=" "  
                step="any"
              />
            </div>
            <div class="label-div d-flex align-items-center justify-content-left col-6 asset-spacing">
              <p>Asset Rating</p>
            </div>
            <div class="col-6 asset-spacing">
              <lib-object-dropdown
                    [items]="filteredAssetRatings"
                    [displayField]="'kvaRating'" 
                    (valueChange)="onAssetRatingSelect($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #assetRatingDropdown
                ></lib-object-dropdown>
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Transformer Winding (Primary)</p>
            </div>
            <div class="col-6">
              <lib-object-dropdown
                    [items]="baseVoltages"
                    [displayField]="'name'" 
                    (valueChange)="onPrimaryWindingSelect($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #baseVoltagePrimaryDropdown
                ></lib-object-dropdown>
            </div>
            <div class="label-div d-flex align-items-center justify-content-left col-6 asset-spacing">
              <p>Transformer Winding (Secondary)</p>
            </div>
            <div class="col-6 asset-spacing">
              <lib-object-dropdown
                    [items]="baseVoltages"
                    [displayField]="'name'" 
                    (valueChange)="onSecondaryWindingSelect($event)"
                    [disabled]="false"
                    [isRequired]="true"
                    #baseVoltageSecondaryDropdown
                ></lib-object-dropdown>
            </div>
          </div>
        </div>         
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal (click)="resetForm()">Cancel</button>
        <button type="submit" class="btn save-modal-btn">{{ isEdit ? 'Update' : 'Save' }}</button>
      </div>
    </form>
  </div>
</div>